export default __webpack_public_path__ + "static/mission-vision-values-211749b46d58770c7600509747e5e7f2.mp4";